/*
  スムーススクロール
*/
const $ = require("jquery");
export default function(e, elHeader) {
  const element = e.target;
  let target;
  // clickした要素がclass属性、js-scrollを含まない場合は処理を中断
  if (!element.classList.contains("js-scroll")) return;
  // gnavのaタグをクリックしたときは親要素を取得する。
  // 今のgnavの構成だと、aタグをクリックしたつもりがimgタグをクリックした判定になってしまっている。
  // 且つ、aタグのhref先には遷移するという挙動。
  // なのでimgタグにもjs-scrollを付与して、条件分岐で親要素を取得するようにした。
  if (element.classList.contains("c-header__logo")) {
    target = element.parentNode;
  } else {
    target = element;
  }

  let browseWidth = window.document.documentElement.clientWidth;
  let targetId = target.hash;
  let id = targetId.slice(1);
  let targetElement = document.getElementById(id);
  // scrollIntoViewでは数値による微調整ができなかったために、SPサイズでは古来の方法を利用。
  if(browseWidth > 1024) {
    e.preventDefault();
    // if((id === "cases" || "support" || "advantage") && !targetElement.parentNode.classList.contains("effect-scroll")) {
    //   targetElement.parentNode.classList.add("effect-scroll");
    // }
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }else {
    //他のイベント処理に干渉しないように
    // if(targetId=='#' || target.isDefaultPr vented())return;
    let position = $(targetId).offset().top;
    // まだフェードインがされていないときは少し高さを調節する。
    if(!targetElement.parentNode.classList.contains("effect-scroll")) {
      position -= ($('#jsScrollHeader').height() + 40);
    } else {
      position -= $('#jsScrollHeader').height() 
    }
    $('body,html').animate({scrollTop: position}, 1000, 'swing');
    e.preventDefault();
  }

  // spのgnavを閉じる。
  if (window.matchMedia( `(max-width: 1024px)` ).matches) {
    const header_element = document.getElementById("jsScrollHeader");
    elHeader.classList.remove('is-active');
    header_element.classList.remove('nav-open');
  }
}